import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Header from "../inc/Header";
import Footer from "../inc/Footer";
import BottomToTop from "../inc/BottomToTop";
import OrderWrapper from "./OrderWrapper";
class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    return (
      <>
        <Header />
        <OrderWrapper />
        <Footer />
        <BottomToTop />
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Contact)
);
